var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item is-inline-block-mobile",attrs:{"aria-label":"Toggle dark mode"},on:{"click":function($event){return _vm.toggleTheme()}}},[_c('i',{staticClass:"fas fa-fw fa-adjust"})])}
var staticRenderFns = []

export { render, staticRenderFns }